<template>
  <div id="app">
    <KoHourlyValues />
  </div>
</template>

<script>
import KoHourlyValues from "./KoHourlyValues.vue";

export default {
  name: 'app',
  components: {
    KoHourlyValues,
  }
}
</script>
